function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.8 4.8A16.3 16.3 0 0116.4 0c4.38 0 8.5 1.7 11.6 4.8 3.1 3.1 4.8 7.22 4.8 11.6 0 2.6-.6 5.08-1.74 7.34l13.42 13.42a5.18 5.18 0 01-7.32 7.33L23.74 31.06A16.34 16.34 0 014.8 28 16.3 16.3 0 010 16.4c0-4.38 1.7-8.5 4.8-11.6zm11.6 21.1c2.53 0 4.92-1 6.71-2.79a9.43 9.43 0 002.78-6.71c0-2.54-.98-4.92-2.78-6.71a9.43 9.43 0 00-6.7-2.78c-2.55 0-4.93.98-6.72 2.78A9.43 9.43 0 006.9 16.4a9.44 9.44 0 009.5 9.5z"
})));